import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import { ListStyles } from '../../constants/textStyleConstants';
import { useEditorContext } from '../../logic/EditorContext';
import AccurityIcon from '../../../icon/components/AccurityIcon';
var ListControls = function () {
    var _a = useEditorContext(), contentHelper = _a[1];
    var handleOnToggle = function (event, type) {
        event.preventDefault();
        contentHelper.toggleBlockType(type);
    };
    var handleOnToggleUnorderedList = function (event) {
        handleOnToggle(event, ListStyles.unorderedList);
    };
    var handleOnToggleOrderedList = function (event) {
        handleOnToggle(event, ListStyles.orderedList);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Tooltip, { title: "Unordered list" },
            React.createElement(AccurityIcon, { iconName: "mui:FormatListBulleted", className: "RichEditor-singleControl", color: contentHelper.blockTypeAtSelection === ListStyles.unorderedList ? 'inherit' : 'disabled', onMouseDown: handleOnToggleUnorderedList, fontSize: "small" })),
        React.createElement(Tooltip, { title: "Ordered list" },
            React.createElement(AccurityIcon, { iconName: "mui:FormatListNumbered", className: "RichEditor-singleControl", color: contentHelper.blockTypeAtSelection === ListStyles.orderedList ? 'inherit' : 'disabled', onMouseDown: handleOnToggleOrderedList, fontSize: "small" }))));
};
export default ListControls;
//# sourceMappingURL=ListControls.js.map